// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse{50%{opacity:.5}}.custom-invitation-modal .modal-card-body{border-bottom-left-radius:5px;border-bottom-right-radius:5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
